import Service from "../../../Services/index";

const Seller = {
    namespaced: true,
    state: {
        data: [],
        replace_data: [],
        customer_sale: []
    },
    mutations: {
        GET_SELLER: (state, res) => {
            state.data = res;
        },
        REPLACE_SELLER: (state, res) => {
            state.replace_data = res;
        },
        GO_TO_SELLER: (state, res) => {
            state.goToSeller = res;
        },
        GET_CUSTOMER_FROM_SALE: (state, res) => {
            state.customer_sale = res;
        },
    },
    actions: {
        get({commit}) {
            return Service.seller
                .getSeller()
                .then(response => {
                    commit("GET_SELLER", response);
                    return response;
                })
        },
        getQuota({commit}) {
            return Service.seller
                .getSellerQuota()
        },
        show({commit}, id) {
            return Service.seller
                .showSeller(id)
                .then(response => {
                    commit("REPLACE_SELLER", response);
                })
                .catch(err => {
                    //console.log(err);
                });
        },
        create({commit}, data) {
            return Service.seller
                .createSeller(data)
                .then(() => {
                    commit("GO_TO_SELLER", true);
                })
        },
        update({commit}, {id, data}) {
            return Service.seller
                .updateSeller(id, data)
                .then(() => {
                    commit("GO_TO_SELLER", true);
                })
        },
        delete({commit}, id) {
            return Service.seller
                .deleteSeller(id)
                .then(() => {
                    commit("GO_TO_SELLER", true);
                })
        },
        search({commit}, keyword) {
            return Service.seller.searchSeller(keyword).then(response => {
                commit("GET_SELLER", response);
            });
        },
        getCustomerFromSale({commit}, data) {
            return Service.seller.getCustomerFromSale(data).then(res => {
                commit("GET_CUSTOMER_FROM_SALE", res);
            })
        },
        getListQuota({commit}) {
            return Service.seller.getListQuota()
        },
        generateNO({commit}) {
            return Service.seller.generateNO()
        },
        checkYTD({commit}, data) {
            return Service.seller.checkYTD(data)
        },
        quotaSubmit({commit}, data) {
            return Service.seller.quotaSubmit(data)
        },
        quotaShow({commit}, data) {
            return Service.seller.quotaShow(data)
        },
        quotaSaleShow({commit}, data) {
            return Service.seller.quotaSaleShow(data)
        },
        quotaSaleHistory({commit}, data) {
            return Service.seller.quotaSaleHistory(data)
        },
        deleteQuota({commit}, id) {
            return Service.seller.deleteQuota(id)
        }
    }
};

export default Seller;
